let _ = require('../_.js');
var $ = jQuery;

/**
 * This file contains functions for initializing custom form components, such as date pickers, and select boxes.
 */

import Flatpickr from 'flatpickr';

/**
 * jQuery compatibility shim for .selectpicker() API
 * Provides backwards compatibility for code that was written for bootstrap-select.
 * TomSelect is now the underlying implementation.
 */
$.fn.selectpicker = function (action, ...args) {
    return this.each(function () {
        const el = this;
        const ts = el.tomselect;

        if (action === 'destroy') {
            if (ts) ts.destroy();
        } else if (action === 'refresh' || action === 'render') {
            if (ts) ts.sync();
        } else if (action === 'val') {
            if (args.length > 0) {
                if (ts) ts.setValue(args[0], true);
                else $(el).val(args[0]);
            }
            return ts ? ts.getValue() : $(el).val();
        } else if (action === 'selectAll') {
            if (ts && el.multiple) {
                const allValues = Object.keys(ts.options);
                ts.setValue(allValues);
            }
        } else if (action === 'deselectAll') {
            if (ts) ts.clear();
        } else if (typeof action === 'object' || action === undefined) {
            // Initialization call - TomSelect will be initialized via on_ui_update
            // Just trigger UI update to ensure initialization happens
            if (typeof _.ui_update === 'function') {
                _.ui_update();
            }
        }
    });
};

_.ac_forms_init = function () {

    // Pressing a clear date button clears the related date on confirmation
    _.on_ui_update_once(".clear-date-btn", function () {
        $(this).on('click', async function () {
            var dateField = $(this).parent().find('input');
            if (await _.Modal.confirm('Are you sure you want to clear the date?')) {
                dateField.val('');
            }
        });
    });

    // Repeater - this feature sucks, it's from a previous developer.  Todo: revisit this
    _.on_ui_update_once(".js-repeater-add-button", function () {
        $(this).on("click", function (e) {
            e.preventDefault();
            let repeaterGroup = $(this).attr("data-for-repeater");
            let $lastField = $("*[data-repeater=" + repeaterGroup + "]").last();
            let $newLastField = $lastField.clone(true).insertAfter($lastField);
            $newLastField.find("*").addBack().val("");
        });
    });

    // More Repeater 
    _.on_ui_update_once(".js-repeater-subtract-button", function () {
        $(this).on("click", function (e) {
            e.preventDefault();
            let repeaterGroup = $(this).attr("data-for-repeater");
            let $fields = $("*[data-repeater=" + repeaterGroup + "]");
            if ($fields.length > 1) {
                $fields.last().remove();
            } else {
                $fields.find("*").addBack().val("");
            }
        });
    });

    // Datetime picker
    _.on_ui_update_once(".datetimepicker", function () {
        $(this).data('flatpickr', new Flatpickr(this, {
            altInput: true,
            altInputClass: "form-control",
            enableTime: true
        }));
    });

    // Date picker
    _.on_ui_update_once(".datepicker", function () {
        $(this).data('flatpickr', new Flatpickr(this, {
            altInput: true,
            altInputClass: "form-control",
            enableTime: false
        }));
    });

    // Date / Datetime val() override
    // This doesn't actually work for value retrieval, it is just setting the input value of the visible proxy input.
    // Use with caution, this really should be fixed.
    (function ($) {
        var originalVal = $.fn.val;
        $.fn.val = function (value) {
            if (typeof value !== 'undefined') {
                var flatpickrInstance = $(this).data('flatpickr');
                if (flatpickrInstance) {
                    // Regex to match date in Y-m-d or Y-m-d H:i:s format
                    var regex = /(\d{4})-(\d{2})-(\d{2})(?: (\d{2}:\d{2}:\d{2}))?/;
                    if (regex.test(value)) {
                        value = value.replace(regex, function (match, year, month, day, time) {
                            return time ? `${month}/${day}/${year} ${time}` : `${month}/${day}/${year}`;
                            // Converting Y-m-d to m/d/Y, preserving time if present
                        });
                    }
                    let $input = $(this).next();
                    $input.val(value); // Setting the date using the converted value
                }
            }
            return originalVal.apply(this, arguments);
        };
    })(jQuery);


    // TomSelect - standard selectpicker
    _.on_ui_update_once('select.selectpicker', function () {
        let el = this;
        let $c = $(this);
        let name = $c.attr('name') || $c.attr('id') || 'unknown';

        // Skip if already initialized
        if (el.tomselect) return;

        let init_tomselect = function () {
            // Skip if already initialized (race condition guard)
            if (el.tomselect) return;

            console.log('[TomSelect] initializing:', name, 'scrollY:', window.scrollY);

            let hasLiveSearch = $c.attr('data-live-search') === 'true';
            let isMultiple = $c.prop('multiple');

            let options = {
                plugins: isMultiple ? ['remove_button'] : [],
                allowEmptyOption: true,
                controlInput: hasLiveSearch ? undefined : null, // null disables search
                onInitialize: function () {
                    console.log('[TomSelect] initialized:', name, 'scrollY:', window.scrollY);
                    // Set initial value from attribute if present
                    let initial_value = $c.attr('value');
                    if (initial_value && this.getValue() !== initial_value) {
                        this.setValue(initial_value, true);
                    }
                }
            };

            new TomSelect(el, options);
        };

        let try_init = function () {
            if (!$c.length) return;
            if ($c.parent().is(":visible")) {
                setTimeout(init_tomselect, 50);
            } else {
                setTimeout(try_init, 100);
            }
        };
        try_init();
    });

    // TomSelect - with custom/tagging input
    _.on_ui_update_once('select.selectpicker-with-custom', function () {
        let el = this;
        let $c = $(this);

        // Skip if already initialized
        if (el.tomselect) return;

        let initial_value = $c.attr('value') || $c.attr('custom_value');

        // If initial value doesn't exist as an option, add it
        if (initial_value && $c.find(`option[value="${initial_value}"]`).length === 0) {
            $c.append(new Option(initial_value, initial_value, true, true));
        }

        new TomSelect(el, {
            create: true, // Allow creating new options
            createOnBlur: true,
            persist: true,
            allowEmptyOption: true,
            onInitialize: function () {
                if (initial_value) {
                    this.setValue(initial_value, true);
                }
            }
        });
    });

    // Datepicker
    _.on_ui_update_once(".datepicker", function () {
        new Flatpickr(this, {
            dateFormat: "Y-m-d H:i:00",
            altInput: true,
            altInputClass: "form-control",
            altFormat: "m/d/Y",
            enableTime: false
        });
    });

    // Show HTML5 validation errors.  If valid form, replace all checkboxes with hidden inputs.
    _.on_ui_update_once("form", function () {
        $(this).on('submit', function (e) {
            // Validation
            $(this).find(':input').each(function () {
                if (!this.validity.valid) {
                    $(this).addClass('is-invalid').css("background-image", "none").css("padding-right", "12px");
                } else {
                    $(this).removeClass('is-invalid');
                }
            });
        });

        // Create hidden elements reflecting checkbox values as either 1 or 0.
        const syncCheckboxToHiddenInput = function (checkbox, hiddenInput) {
            hiddenInput.val(checkbox.is(':checked') ? 1 : 0);
        };

        // Iterate over each checkbox
        $(this).find('input[type="checkbox"][name]').each(function () {

            // Get the original name
            let originalName = $(this).attr('name');

            // Change the name of the checkbox
            $(this).attr('name', originalName + '_check');

            // Create a hidden input element with the original name
            let hiddenInput = $('<input>', {
                type: 'hidden',
                name: originalName,
                value: $(this).is(':checked') ? 1 : 0
            });

            // Append this hidden input after the checkbox
            $(this).after(hiddenInput);

            // Setup event listener for checkbox changes
            $(this).on('change', function () {
                syncCheckboxToHiddenInput($(this), hiddenInput);
            });
        });

        // Sync checkbox values to hidden inputs on form submit
        $(this).on('submit', function () {
            $(this).find('input[type="checkbox"][name]').each(function () {
                let hiddenInput = $(this).siblings('input[name="' + $(this).attr('name').replace('_check', '') + '"]');
                syncCheckboxToHiddenInput($(this), hiddenInput);
            });
        });
    });

    // Tinymce
    _.on_ui_update_once('textarea.tinymce', function () {
        if (!this.id) {
            this.id = _.uniqueId('tinymce-');
        }

        // Initialize TinyMCE using the id as the selector
        tinymce.init({
            selector: '#' + this.id, // Use the id as the selector
            plugins: "image link responsivefilemanager",
            relative_urls: false,
            remove_script_host: false,
            file_picker_callback: _.ac_dropzone_filebrowser,
            external_filemanager_path: "/filemanager/",
            filemanager_title: "Responsive Filemanager",
            external_plugins: { filemanager: "/filemanager/plugin.min.js" },
            // Commenting these out since Responsive Filemanager now takes care of file uploading for TinyMCE
            toolbar:
                "undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image",
            invalid_elements: "h1",
            style_formats: [
                {
                    title: "Headings",
                    items: [
                        { title: "Heading 2", format: "h2" },
                        { title: "Heading 3", format: "h3" },
                        { title: "Heading 4", format: "h4" },
                        { title: "Heading 5", format: "h5" },
                        { title: "Heading 6", format: "h6" }
                    ]
                },

                {
                    title: "Inline",
                    items: [
                        { title: "Bold", icon: "bold", format: "bold" },
                        { title: "Italic", icon: "italic", format: "italic" },
                        {
                            title: "Underline",
                            icon: "underline",
                            format: "underline"
                        },
                        {
                            title: "Strikethrough",
                            icon: "strikethrough",
                            format: "strikethrough"
                        },
                        {
                            title: "Superscript",
                            icon: "superscript",
                            format: "superscript"
                        },
                        {
                            title: "Subscript",
                            icon: "subscript",
                            format: "subscript"
                        },
                        { title: "Code", icon: "code", format: "code" }
                    ]
                },

                {
                    title: "Blocks",
                    items: [
                        { title: "Paragraph", format: "p" },
                        { title: "Blockquote", format: "blockquote" },
                        { title: "Div", format: "div" },
                        { title: "Pre", format: "pre" }
                    ]
                },

                {
                    title: "Alignment",
                    items: [
                        { title: "Left", icon: "alignleft", format: "alignleft" },
                        {
                            title: "Center",
                            icon: "aligncenter",
                            format: "aligncenter"
                        },
                        {
                            title: "Right",
                            icon: "alignright",
                            format: "alignright"
                        },
                        {
                            title: "Justify",
                            icon: "alignjustify",
                            format: "alignjustify"
                        }
                    ]
                }
            ],
            images_upload_headers: {
                "X-CSRF-Token": jQuery('[name="_token"]').val(),
                _method: "POST"
            },
            setup: function (ed) {

                ed.on('init', function (args) {
                    _.ui_update();
                });

                // Changes emit change events and save to the underlying textarea immediatly
                ed.on('Change', function (e) {
                    ed.save();
                    $(ed.getElement()).trigger('change');
                });

                // jQuery hook into the textarea's change event to sync back into editor
                $(ed.getElement()).on('change', function () {
                    var newText = $(this).val();
                    if (newText !== ed.getContent()) {
                        editor.setContent(newText);
                    }
                });
            }
        });
    });

    // Simulate read only for _.tinymce
    _.on_ui_update_always('textarea.tinymce', function () {
        var textarea = $(this);
        var tinymceDiv = textarea.siblings('.mce-tinymce');

        if (textarea.is('[readonly]')) {
            // textarea is readonly, add overlay if it doesn't exist
            if (tinymceDiv.children('.overlay').length === 0) {
                $('<div class="overlay" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.06); z-index: 10;"></div>')
                    .appendTo(tinymceDiv);
            }
        } else {
            // textarea is not readonly, remove overlay if it exists
            tinymceDiv.children('.overlay').remove();
        }
    });

    /* Removes form validation errors. */
    _.reset_form_errors = function (parentSelector) {
        var $parent = $(parentSelector);

        // Remove flash messages
        $(".flash-messages").remove();

        // Remove alert-danger messages
        $parent.find('.alert-danger').remove();

        // Remove validation error classes and text from form elements
        $parent.find('.is-invalid').removeClass('is-invalid');
        $parent.find('.invalid-feedback').remove();
    }

    /* Shows form validation errors.  If the errors are an object of key value pairs, the errors for named input fields are shown on their associated input box. */
    _.apply_form_errors = function (parentSelector, errors) {
        console.error(errors);

        const $parent = $(parentSelector);

        // Reset the form errors before applying new ones
        _.reset_form_errors(parentSelector);

        if (errors && errors.hasOwnProperty && errors.hasOwnProperty('errors')) {
            errors.error = errors.errors;
            delete errors.errors;
        }

        if (errors && errors.hasOwnProperty && errors.hasOwnProperty('error')) {
            errors = errors.error;

            // Convert from laravel blade validator syntax
            let formattedErrors = {};
            for (const field in errors) {
                if (errors.hasOwnProperty(field) && Array.isArray(errors[field])) {
                    const errorMessage = errors[field][0];
                    formattedErrors[field] = errorMessage;
                } else {
                    // Preserve any fields that were not moved
                    formattedErrors[field] = errors[field];
                }
            }

            errors = formattedErrors;
        }

        if (errors && Array.isArray(errors) && errors.length > 0 && typeof errors[0] === 'object') {
            errors = errors[0];
        }

        return new Promise(resolve => {
            let animations = [];

            if (typeof (errors) === 'string') {
                const $alert = $('<div class="alert alert-danger" role="alert"></div>').text(errors);
                animations.push($alert.hide().prependTo($parent).fadeIn(300).promise());
            } else {
                const unmatchedErrors = {};

                for (const key in errors) {
                    const $input = $parent.find('[name="' + key + '"]');

                    if ($input.length) {

                        const $error = $('<div class="invalid-feedback"></div>').html(errors[key]);
                        let $target = $input.closest('.form-group, .form-check, .input-group');

                        if ($target.length) {

                            if (!$target.hasClass('input-group-ac')) {
                                $input.addClass('is-invalid').css("background-image", "none").css("padding-right", "12px");
                                $error.appendTo($target);
                            } else {
                                // Must be positioned after these, because flex.
                                $input.parent().addClass('is-invalid').css("background-image", "none").css("padding-right", "12px");
                                $target.after($error);
                            }

                            animations.push($error.hide().fadeIn(300).promise());

                        } else {
                            unmatchedErrors[key] = errors[key];
                        }
                    } else {
                        unmatchedErrors[key] = errors[key];
                    }
                }

                // Remove duplicate unmatchedErrors
                const uniqueValues = new Set();
                for (const key in unmatchedErrors) {
                    const value = unmatchedErrors[key];
                    if (uniqueValues.has(value)) {
                        delete unmatchedErrors[key];
                    } else {
                        uniqueValues.add(value);
                    }
                }

                if (!$.isEmptyObject(unmatchedErrors)) {
                    const $alert = $('<div class="alert alert-danger" role="alert"><ul></ul></div>');
                    if (unmatchedErrors.message) {
                        console.error(unmatchedErrors.message);
                        $('<li></li>').html(unmatchedErrors.message).appendTo($alert.find('ul'));
                    } else {
                        for (const key in unmatchedErrors) {
                            let text = (unmatchedErrors[key] + "").trim();
                            if (!text || text == "") {
                                text = "An error has occurred with your request";
                            }
                            $('<li></li>').html(text).appendTo($alert.find('ul'));
                        }
                    }
                    animations.push($alert.hide().prependTo($parent).fadeIn(300).promise());
                }
            }

            // Pass the errors to _.flash_error if no errors are printed
            if (animations.length === 0) {
                _.flash_error(errors);
            }

            // Resolve the promise once all animations are complete
            Promise.all(animations).then(resolve);
        });
    }

    /* Removes form validation errors. */
    _.reset_form_values = function ($form) {
        const $ = window.jQuery;
        $form.trigger("reset");
    }

    /* Returns key value pairs of all input elements with a name="" attribute on the form as an object. */
    _.serialize_form = function ($form) {
        var data = {};

        $form.serializeArray().forEach(function (item) {
            data[item.name] = item.value;
        });

        // // Handle checkbox input types
        // $form.find('input[type=checkbox]').each(function () {
        //     // If checkbox has a name attribute
        //     if ($(this).attr('name')) {
        //         // The key in 'data' will be the checkbox's name attribute, and the value will be 'true' or 'false'
        //         data[$(this).attr('name')] = $(this).is(':checked');
        //     }
        // });

        return data;
    };


}
